// TODO: rename: "DisabilityAndUnpaidCare"
import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

module.exports = {
  // "Disability": ({data, geo, geo_aggregation}) => <div>Table</div>,
  // "Unpaid Care": ({data, geo, geo_aggregation}) => <div>Table</div>
}



// WEBPACK FOOTER //
// ./components/Tables/Other.js